import { Injectable } from '@angular/core';
import {ArticleMarketplaceData} from "../../../../types/marketplace.types";
import {FilterArticlesParams} from "../types/article-marketplace-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ArticleMarketplaceModalService {
  public filterArticles(filterArticlesParams: FilterArticlesParams): Array<ArticleMarketplaceData> {
    const { searchValue, articleMarketplaceData } = filterArticlesParams;
    if (!searchValue?.trim()) return articleMarketplaceData;

    const searchTerm = searchValue.trim();
    const searchLower = searchTerm.toLowerCase();
    const searchAsNumber = Number(searchTerm);
    const getItemFields = (item: ArticleMarketplaceData): unknown[] => [
      item.id,
      item.nmId,
      item.id?.toString(),
      item.nmId?.toString(),
      item.title
    ].filter(Boolean);

    const fieldMatchesSearch = (field: unknown): boolean => {
      const type = typeof field;
      const comparisons: Record<string, () => boolean> = {
        number: () => field === searchAsNumber,
        string: () => (field as string).toLowerCase().includes(searchLower) || field === searchTerm,
      };

      return comparisons[type]?.() ?? false;
    };

    return articleMarketplaceData.filter(item =>
      getItemFields(item).some(fieldMatchesSearch)
    );
  }
}
